import React from "react";

export const errMsg = (e) => (typeof e?.response?.data?.detail === "string" ? e.response.data.detail : "Request failed");

export const PERM = {
  granted: ["Consent granted", "bg-emerald-50 text-emerald-700 border-emerald-200"],
  soft_opt_in: ["Soft opt-in", "bg-teal-50 text-teal-700 border-teal-200"],
  unknown: ["Unknown", "bg-slate-50 text-slate-600 border-slate-200"],
  no_consent: ["No consent", "bg-amber-50 text-amber-700 border-amber-200"],
  withdrawn: ["Withdrawn", "bg-rose-50 text-rose-700 border-rose-200"],
};

export const STATUS = { subscribed: "Subscribed", not_subscribed: "Not subscribed", unsubscribed: "Unsubscribed" };

export function PermBadge({ value, testId }) {
  const [label, cls] = PERM[value] || [value, "bg-slate-50 text-slate-600 border-slate-200"];
  return <span className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-semibold ${cls}`} data-testid={testId}>{label}</span>;
}

export function EligibleBadge({ sub, testId }) {
  if (sub.eligible) return <span className="text-[11px] font-semibold text-emerald-700" data-testid={testId}>Eligible</span>;
  const why = sub.suppressed ? "Suppressed" : !sub.email_valid ? (sub.email ? "Invalid email" : "No email") : "No consent";
  return <span className="text-[11px] font-medium text-slate-400" data-testid={testId}>{why}</span>;
}

export function Stat({ label, value, hint, tone = "slate", testId }) {
  const tones = { slate: "text-slate-900", emerald: "text-emerald-700", amber: "text-amber-700", rose: "text-rose-700", indigo: "text-indigo-700" };
  return (
    <div className="bg-white border border-slate-200 rounded-xl p-4" data-testid={testId}>
      <p className="text-[11px] font-semibold uppercase tracking-wider text-slate-400">{label}</p>
      <p className={`text-2xl font-bold tabular-nums mt-1 ${tones[tone]}`}>{(value ?? 0).toLocaleString()}</p>
      {hint && <p className="text-[11px] text-slate-400 mt-1">{hint}</p>}
    </div>
  );
}

export function Card({ title, right, children, testId }) {
  return (
    <section className="bg-white border border-slate-200 rounded-xl" data-testid={testId}>
      {title && (
        <div className="flex items-center justify-between gap-3 px-4 py-3 border-b border-slate-100">
          <h2 className="text-sm font-semibold text-slate-800">{title}</h2>
          {right}
        </div>
      )}
      <div className="p-4">{children}</div>
    </section>
  );
}
